import { render, staticRenderFns } from "./Lastpart.vue?vue&type=template&id=3e551808&scoped=true&"
import script from "./Lastpart.vue?vue&type=script&lang=js&"
export * from "./Lastpart.vue?vue&type=script&lang=js&"
import style0 from "./Lastpart.vue?vue&type=style&index=0&id=3e551808&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e551808",
  null
  
)

export default component.exports